import * as React from 'react';
import styled from '@emotion/styled';
import {
    space,
    layout,
    color,
    system,
    compose,
    position
} from 'styled-system';
import { Box, BoxProps } from '../box';

const svg = system({
    fill: {
        property: 'fill',
        scale: 'colors'
    },
    stroke: {
        property: 'stroke',
        scale: 'colors'
    }
});

const SvgBox = styled(Box)`
    ${compose(
        svg
    )}
`;

const Svg: React.FC<BoxProps> = (
    React.forwardRef((props: BoxProps, ref: React.ElementRef<any>) => (
        <SvgBox as="svg" ref={ref} {...props} />
    ))
);

export default Svg;
